import {defineStore} from "pinia";
import {ref} from "vue";

export const useDayStore = defineStore('day', () => {
    // 1. state => ref
    // 2. getters => computed
    // 3. actions => function

    const ymd = ref('');
    const ym = ref('');
    const md = ref('');
    const yy = ref('');
    const mt = ref('');
    const dd = ref('');
    const dayNum = ref('');
    const dayKor = ref('');

    const set = (day) => {
        ymd.value = day.ymd;
        ym.value = day.ym;
        md.value = day.md;
        yy.value = day.yy;
        mt.value = day.mt;
        dd.value = day.dd;
        dayNum.value = day.dayNum;
        dayKor.value = day.dayKor;
    }

    const get = () => {
        return {
            ymd: ymd.value,
            ym: ym.value,
            md: md.value,
            yy: yy.value,
            mt: mt.value,
            dd: dd.value,
            dayNum: dayNum.value,
            dayKor: dayKor.value
        }
    }

    return {ymd, ym, md, yy, mt, dd, dayNum, dayKor, set, get};
})